var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportProcessingNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 206,
    viewBox: "0 0 206 206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#0BB",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-409 -325) translate(60 229) translate(349 96)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.008 30.015L37.519 30.015M15.008 45.023L55.028 45.023M15.008 60.031L45.024 60.031M15.008 75.039L40.02 75.039",
    transform: "translate(46 49)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.025 105.053H2.944c-1.626 0-2.944-1.317-2.944-2.943V2.944C0 1.317 1.318 0 2.944 0h50.865c.78 0 1.53.31 2.081.862L79.178 24.15c.553.552.863 1.302.863 2.082v18.791",
    transform: "translate(46 49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.028 0L55.028 25.013 80.041 25.013",
    transform: "translate(46 49)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "rotation"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115 86.564L106.157 95.407 97.313 86.564",
    transform: "translate(46 49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32 63.572c8.363-3.998 19.602-1.625 26.53 5.305 6.93 6.93 9.303 18.169 5.307 26.53M54.865 83.026L63.709 74.183 72.552 83.026",
    transform: "translate(46 49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.545 106.02c-8.366 4-19.6 1.623-26.53-5.307-6.93-6.929-9.307-18.165-5.306-26.53",
    transform: "translate(46 49)"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 102
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportProcessingNew);
export default __webpack_public_path__ + "static/media/import-processing-new.c824fae699c89ee52ccee58516e68e04.svg";
export { ForwardRef as ReactComponent };